import React from 'react'
import { Link } from 'react-router-dom'
import ApproveRequestsPage from '../admin/ApproveRequestsPage'

export default function SettingsPage({ user, familyId }) {
  return (
    <div className="min-h-[calc(100vh-64px)] py-6">
      <div className="max-w-7xl mx-auto px-4 space-y-6">
        {/* Add Family */}
        <div className="glass-card p-6">
          <h2 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 dark:from-blue-400 dark:to-purple-400 bg-clip-text text-transparent mb-2">
            Families
          </h2>
          <p className="text-gray-600 dark:text-gray-400 text-sm mb-4">
            Join an existing family or create a new one
          </p>
          <Link to="/family/new" className="glass-btn-primary glass-btn-sm inline-flex items-center gap-2">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Add Family
          </Link>
        </div>

        {/* Access Requests */}
        <ApproveRequestsPage user={user} familyId={familyId} />
      </div>
    </div>
  )
}
